// state.po.itemID not null that mean modify order items
// state.po.currentID null that mean add new order.
// back to order list need clear state.po.currentID and state.po.itemID and state.po.order_no

import React, { useEffect, useState } from "react";
import { Button, List } from "antd";
import { getDataForTable, SearchParamsInterface } from "../../Utils/getDataForTable";
import { CheckOutlined } from "@ant-design/icons";
import { useStateContext } from "../../Store/StateProvider";
import { defaultStateType } from "../../Store/defaultStatus";
import {useHistory} from 'react-router-dom'

import { poAction } from "../../Reducers/po_reducer";

export default function ListOrder(props: any) {
  let [data, setData] = useState([]);
  let [pageTotal, setPageTotal] = useState();
  let [state, dispatch] = useStateContext();
  let history=useHistory()

  let [
    pageSize,
    pageNo,
    searchField,
    searchContent,
    between,
    conditionType,
    queryType,
    orderBy,
    sortBy,
  ] = Object.values(state.po);

  useEffect(() => {
    getDataForTable(
      {
        pageSize,
        pageNo,
        searchField,
        searchContent,
        between,
        conditionType,
        queryType,
        orderBy,
        sortBy,
      } as SearchParamsInterface,
      setData,
      setPageTotal,
      "/api/pos",
      "GET"
    );
    // fetchTableData();
  }, [
    pageSize,
    pageNo,
    searchField,
    searchContent,
    between,
    conditionType,
    queryType,
    orderBy,
    sortBy,
    state.po.reloadFlag,
  ]);

  return (
    <div
      style={{
        display: "table",
        width: "100%",
        height: "100%",
        maxHeight: "100%",
      }}
    >
      <div style={{ display: "table-row" }}>
        <div style={{ display: "table-cell", textAlign: "center" }}>
          <List
           style={{maxHeight:580,height:575,overflow: 'hidden'}}
            pagination={{
              onChange: (page) => {
                dispatch(
                  poAction({
                    pageNo: page,
                    reloadFlg: !(data as defaultStateType).order?.reloadFlag,
                  })
                );
              },
              current: Number(pageNo),
              total: pageTotal,
              pageSize: Number(pageSize),
              defaultPageSize: 6,
            }}
            size="large"
            bordered
            dataSource={data}
            renderItem={(item: any) => (
              <List.Item>
                <div style={{ display: "table", width: "100%" }}>
                  <div style={{ display: "table-cell", width: "50%" }}>
                  {item.user.user_name}<br/>
                    {//item.order_no
                    item.id
                    }
                  </div>{" "}
                  <div style={{ display: "table-cell" }}>
                    {item.finished ? (
                     
                      <Button
                        type="text"
                        onClick={() => {
                          dispatch(poAction({currentID:item.id,order_no:item.order_no}));
                          history.push('/main/podetail')
                        }}
                        icon={ <CheckOutlined style={{ color: "green" }} />}
                      >
                        查看
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          dispatch(poAction({currentID:item.id,order_no:item.order_no}));
                          history.push('/main/podetail')
                        }}
                      >
                        修改
                      </Button>
                    )}
                  </div>{" "}
                </div>
              </List.Item>
            )}
          />
        </div>
      </div>
    </div>
  );
}
